import { apiClient, getPlatformUrl } from "../../lib/api";

export class SupportGateway {
  async clearCache(): Promise<any> {
    const url = `${getPlatformUrl()}/xcausal/v1/operation/redis/cache`;
    const res = await apiClient.remove({ url: url });
    return res as any;
  }

  async fetchIntegrateFlg(): Promise<any> {
    const url = `${getPlatformUrl()}/xcausal/v1/operation/settings/app-integration`;
    const res = await apiClient.get({ url: url });
    return res as any;
  }

  async toggleIntegrateFlg(): Promise<any> {
    const url = `${getPlatformUrl()}/xcausal/v1/operation/settings/app-integration`;
    const res = await apiClient.patch({ url: url });
    return res as any;
  }
}
